module.exports = __webpack_public_path__ + "img/achievement-course6.d5a1c455.png";